var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8683_3115",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8683_3115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3998 13.5513L24.9972 8.93327L24.1665 8.10261L20.3998 11.8693L18.4998 9.98194L17.6692 10.8333L20.3998 13.5513ZM4.6665 26.3333V24.6579H19.9998V26.3333H4.6665ZM21.3322 16.8376C19.6246 16.8376 18.1694 16.2358 16.9665 15.0323C15.7636 13.8287 15.1622 12.3732 15.1622 10.6656C15.1622 8.95805 15.7639 7.50283 16.9675 6.29994C18.1711 5.09705 19.6266 4.49561 21.3342 4.49561C23.0417 4.49561 24.497 5.09738 25.6998 6.30094C26.9027 7.5045 27.5042 8.96005 27.5042 10.6676C27.5042 12.3752 26.9024 13.8304 25.6988 15.0333C24.4953 16.2362 23.0397 16.8376 21.3322 16.8376ZM4.6665 15.3419V13.6666H12.6135C12.7213 13.9746 12.8386 14.2648 12.9655 14.5373C13.0922 14.8097 13.2358 15.0779 13.3965 15.3419H4.6665ZM4.6665 20.8376V19.1623H17.8092C18.1469 19.3176 18.5006 19.4475 18.8702 19.5519C19.2397 19.6564 19.6163 19.7354 19.9998 19.7889V20.8376H4.6665Z",
    fill: "#054BC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesIcon);
export default __webpack_public_path__ + "static/media/activities_icon.2ce4f109fdc638bd9069df2868cb7cfa.svg";
export { ForwardRef as ReactComponent };